import { MOKA_GOAUTH_SERVICE } from '../constants';

export const SAUDAGAR_OUTLETS_ME = `${MOKA_GOAUTH_SERVICE}/saudagar/outlets/me`;
